module.exports = __webpack_public_path__ + "img/preSession-1.14ee18ee.jpg";